import { Type, type Static } from '@sinclair/typebox';
import { MessageFileUploadSchema } from '../../shared/file/file-request.schema';

export const GetAttachmentParamsSchema = Type.Object({
  chat_id: Type.String({ minLength: 1, description: 'The ID of the Chat where the parent message of the attachment is.' }),
  message_id: Type.String({ minLength: 1, description: 'The ID of the Message where the attachment is.' }),
  attachment_id: Type.String({ minLength: 1, description: 'The ID of the Attachment to retrieve.' }),
});

export const SendAttachmentSchema = Type.Optional(
  Type.Array(MessageFileUploadSchema, {
    description: 'The list of file attachments to the message to be sent in the chat.',
  }),
);

export const SendMessageAttachmentSchema = Type.Union([MessageFileUploadSchema]);

export const SendMessageAttachmentsSchema = Type.Optional(
  Type.Array(SendMessageAttachmentSchema, {
    description: 'The list of attachments (uploaded files or a shared post or job) to be sent with the message.',
  }),
);

export type GetAttachmentParams = Static<typeof GetAttachmentParamsSchema>;
export type SendMessageAttachment = Static<typeof SendMessageAttachmentSchema>;
